export default "__VITE_ASSET__DLdClUWO__"